import { render, staticRenderFns } from "./createSeparation.vue?vue&type=template&id=920c2218"
import script from "./createSeparation.vue?vue&type=script&lang=js"
export * from "./createSeparation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports